import cookie from 'js-cookie'

import {abTestConfigCookieName, visitorCookieValidityInDays} from '../constants/http'
import {ABTestConfig} from './config'

// The only writer of the assignment: `ABTestProvider` on every page load, and the debug modal's
// switches
export const writeABTestConfigCookie = (config: ABTestConfig) => {
  cookie.set(abTestConfigCookieName, JSON.stringify(config), {
    expires: visitorCookieValidityInDays,
    sameSite: 'lax',
  })
}
